export default "__VITE_ASSET__$jq0pbHL__"